<template>
  <v-layout row wrap>
    <v-flex xs12>
      <SummaryTitle
        :isCollapsible="isCollapsible"
        :isCollapsed="isCollapsed"
        icon="assignment_turned_in"
        @clickedToggle="toggleIsCollapsed">
        Services
        <template v-if="displayAction" v-slot:action>
          <EditButton @click="clickEditServices" />
        </template>
      </SummaryTitle>
    </v-flex>

    <v-flex v-if="!contentIsCollapsed" xs12>
      <SummaryEstimateItem
        v-for="item in estimateItems"
        :key="`estimate_item_${item.invoiceItemId}`"
        :name="item.serviceName"
        :price="item.subtotal"
        :quantity="item.quantity" />
      <SummaryEstimateItem
        v-if="isShowServicePricesEnabled"
        name="Tax"
        :price="estimateTax" />
      <SummaryEstimateItem
        v-if="isShowServicePricesEnabled"
        emphasis
        name="Total"
        :price="estimateTotal" />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';

import EditButton from '@/components/common/EditButton.vue';
import SummaryEstimateItem from '@/components/SummaryEstimateItem.vue';
import SummaryTitle from '@/components/common/SummaryTitle.vue';
import CollapsibleSection from '@/mixins/CollapsibleSection';
import StepUtilities from '@/router/utilities/step-utilities';
import FeatureFlagUtil from '@/utilities/feature-flag-util';

export default {
  components: {
    EditButton,
    SummaryEstimateItem,
    SummaryTitle,
  },
  mixins: [CollapsibleSection],
  computed: {
    ...mapState('Appointment', {
      estimateItems: state => (state.servicesComponentData.estimate
        ? state.servicesComponentData.estimate.invoiceItems
        : []),
      estimateTax: state => (state.servicesComponentData.estimate
        ? state.servicesComponentData.estimate.tax
        : 0),
      estimateTotal: state => (state.servicesComponentData.estimate
        ? state.servicesComponentData.estimate.total
        : 0),
    }),
  },
  data() {
    return {
      isShowServicePricesEnabled: FeatureFlagUtil.isShowServicePricesEnabled(),
    };
  },
  methods: {
    clickEditServices() {
      StepUtilities.goToServicesStep(this.$router);
    },
  },
};
</script>
